<template>
    <a-modal
      :width="600"
      :maskClosable="false"
      :keyboard="false"
      :visible="visible"
      @cancel="onClose"
      :destroyOnClose="true"
    >
      <h2 slot="title" style="text-align:center">设备检测</h2>
      <div slot="footer">
        <a-button :disabled="!deviceTestResult.browser" v-if="currentTab==0" type="primary" @click="currentTab=1" icon="double-right">下一步</a-button>
        <a-button :disabled="!deviceTestResult.camera" v-if="currentTab==1" type="primary" @click="closeStream();currentTab=2" icon="double-right">下一步</a-button>
        <a-button :disabled="!deviceTestResult.screenrecord" v-if="currentTab==2" type="primary" @click="checkFinish" icon="check">完成检测</a-button>
      </div>
      <div>
    <a-steps class="steps" :current="currentTab">
      <a-step title="浏览器检测"/>
      <a-step title="摄像头检测"/>
      <a-step title="录屏检测"/>
    </a-steps>
    <a-divider></a-divider>
        <div v-if="currentTab==0">
            <p>请在更换电脑或浏览器后进行环境检测，否则可能影响后续考试。</p>
            <a-alert v-if="deviceTestResult.browser" :message="$t('exam.broswerPass')" type="success" show-icon />
            <a-alert v-else type="warning" show-icon >
              <template slot="message">
                  <p>{{$t('exam.broswerSuggest')}}</p>
                  <a href="https://www.google.cn/chrome/" target="_blank">{{$t('sys.download')}}</a>
              </template>
            </a-alert>
        </div>
        <div v-if="currentTab==1">
          <a-row :gutter="2">
            <a-alert v-if="cameraList && cameraList.length>1" type="warning" show-icon >
              <div slot="message">
                  <p>您的设备有多个摄像头，请选择一个：</p>
                  <a-select :default-value="currentCamera" style="width: 200px" @change="handleSelectCamera">
                    <a-select-option v-for="i in cameraList" :value="i.id" :key="i.id">
                      {{i.label}}
                    </a-select-option>
                  </a-select>
                </div>
            </a-alert>
            <a-divider v-if="cameraList && cameraList.length>1"></a-divider>
            <a-col :span="12">
              <video class="video-check-preview" muted id="video-camera" width="240" height="160"></video>
              <a-button v-if="!deviceTestResult.camera" class="enable-check-btn" type="primary" @click="enableCameraRecorder()">点击开启摄像头</a-button>
            </a-col>
            <a-col :span="12">
              <a-alert v-if="!deviceTestResult.camera && deviceTestResult.failedReasonCamera" type="error">
                <template slot="message">
                    <p>{{$t('exam.cameraNotPass')}}</p>
                    <p>{{$t('sys.errReason')}}:{{ deviceTestResult.failedReasonCamera }}</p>
                    <a-button @click="enableCameraRecorder" type="link">{{$t('sys.retry')}}</a-button>
                </template>
              </a-alert>
              <a-alert v-if="deviceTestResult.camera" :message="$t('exam.cameraPass')" type="success" show-icon />
            </a-col>
          </a-row>
        </div>
        <div v-if="currentTab==2">
          <a-row :gutter="2">
            <a-col :span="12">
              <video class="video-check-preview" muted id="video-screen" width="240" height="160"></video>
              <a-button v-if="!deviceTestResult.screenrecord" class="enable-check-btn" type="primary" @click="enableScreenRecorder()">点击开启录屏</a-button>
            </a-col>
            <a-col :span="12">
              <a-alert v-if="!deviceTestResult.screenrecord && deviceTestResult.failedReasonScreen" type="error">
                <template slot="message">
                    <p>{{$t('exam.screenRecorderNotPass')}}</p>
                    <p>{{$t('sys.errReason')}}:{{ deviceTestResult.failedReasonScreen }}</p>
                    <a-button @click="enableScreenRecorder" type="link">{{$t('sys.retry')}}</a-button>
                </template>
              </a-alert>
              <a-alert v-if="deviceTestResult.screenrecord" :message="$t('exam.screenRecorderPass')" type="success" show-icon />
            </a-col>
          </a-row>
        </div>
      </div>
    </a-modal>
</template>
<script>
import Vue from 'vue'
import { putAction } from '@/api/manage'
import { USER_INFO } from '@/store/mutation-types'
export default {
  name: "ExamEnvCheckModal",
  data() {
    return {
      visible: false,
      currentTab:0,
      deviceTestResult: {
        browser: false, //浏览器
        camera: false, //摄像头
        microphone: false, //麦克风
        screenrecord: false, //屏幕录制
        failedReasonCamera: '',
        failedReasonScreen: ''
      },
      cameraList: [],
      currentCamera: '',
      mediaRecorder: null,
      screenRecorder: null,
      videoCameraDom: null,
      videoScreenDom: null,
    };
  },
  created(){
      this.deviceTestResult = {
        browser: false, //浏览器
        camera: false, //摄像头
        microphone: false, //麦克风
        screenrecord: false, //屏幕录制
        failedReasonCamera: '',
        failedReasonScreen: ''
      }
  },
  mounted(){
    let that = this
    window.onblur = function () {
      that.closeStream()
    };
  },
  methods: {
    open(){
      this.visible = true
      this.deviceTestResult = {
        browser: false, //浏览器
        camera: false, //摄像头
        microphone: false, //麦克风
        screenrecord: false, //屏幕录制
        failedReasonCamera: '',
        failedReasonScreen: ''
      }
      this.closeStream()
      this.checkBroswer()
      this.getCameraList()
    },
    hide(){
      this.visible = false
    },
    checkFinish(){
      putAction("/sys/user/examEnvCheck", {
        browser: this.deviceTestResult.browser,
        camera: this.deviceTestResult.camera,
        screenrecord: this.deviceTestResult.screenrecord,
      }).then(res=>{
        let userInfo = Vue.ls.get(USER_INFO)
        userInfo['examCheckStatus'] = 1
        Vue.ls.set(USER_INFO, userInfo)
        this.$message.info('当前设备已通过环境检测')
      })
      this.onClose()
    },
    onClose(){
      this.closeStream()
      this.visible=false
      this.currentTab=0;
    },
    closeStream(){
      
      if(this.videoCameraDom){
        if(this.videoCameraDom.srcObject)
          this.videoCameraDom.srcObject.getTracks().forEach(function(track) {
            track.stop();
          });
        this.videoCameraDom.srcObject = null
      }
       
      if(this.videoScreenDom){
        if(this.videoScreenDom.srcObject)
          this.videoScreenDom.srcObject.getTracks().forEach(function(track) {
            track.stop();
          });
        this.videoScreenDom.srcObject = null
      }
        
      if(this.screenRecorder)
        this.screenRecorder.stop()
      if(this.mediaRecorder)
        this.mediaRecorder.stop()
    },
    
    //获取摄像头列表
    getCameraList(){
      let that = this
      let lastCameraId = Vue.ls.get("currentCamera")
      navigator.mediaDevices.enumerateDevices().then(function(devices) {
        console.log(devices)
        devices.forEach(function(device) {
          if(device.kind == 'videoinput'){
            that.cameraList.push({
              'label': device.label,
              'id': device.deviceId
            })
            // 自动选择上次的摄像头
            if(device.deviceId == lastCameraId){
              that.currentCamera = lastCameraId
            }
          }
        });
        //如果上次选择的摄像头找不到了，默认选择第一个
        if(!that.currentCamera && that.cameraList.length>0) that.currentCamera = that.cameraList[0].id
      }).catch(function(err) {
        console.log(err.name + ": " + err.message);
      });
    },
    handleSelectCamera(v){
      console.log("selected camera", v);
      this.currentCamera = v
      Vue.ls.set("currentCamera", v)
      window.mediaStreamTrack && window.mediaStreamTrack.stop();
      this.mediaRecorder && this.mediaRecorder.stop();
      this.mediaRecorder && this.mediaRecorder.stream && this.mediaRecorder.stream.stop();

      this.enableCameraRecorder()
    },
    //开启摄像头录像
    enableCameraRecorder() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      if (navigator.getUserMedia) {
        navigator.getUserMedia({
          video: {
            deviceId: this.currentCamera,
            width: {  ideal: 640, max: 1920 },
            height: {  ideal: 480, max: 1080 },
            frameRate: { max: 20 },
          },
          audio:true
        }, 
        this.onCameraSuccess, this.onCameraError);
      } else {
        this.deviceTestResult.camefra = false
        this.deviceTestResult.microphone = false
        this.$message.error(this.$t('exam.cameraNotSupport'))
      }
    },
    //开启屏幕录像
    enableScreenRecorder(){
      let that = this
      if(!navigator.mediaDevices){
        //不支持https
        return;
      }
      let width = window.screen.width
      let height = window.screen.height
      navigator.mediaDevices.getDisplayMedia(
        {
          video:{
            mediaSource:'screen',
            width: width,
            height: height,
            frameRate: { max: 20 },
            displaySurface: "monitor"
          },
          // surfaceSwitching: 'exclude', //禁止跨页分享按钮
          // preferCurrentTab: true, // 默认分享当前页
        }
      ).then(stream=>{
        that.onScreenSuccess(stream)
      }, error=>{
        that.onScreenError(error)
      })
    },
     onScreenSuccess(stream){
      console.log("已开启屏幕录制");
      const track = stream.getVideoTracks()[0];
      const settings = track.getSettings();
      console.log("录屏流属性：", settings);
      this.deviceTestResult.screenrecord = true
      this.screenrecordTipVisible = false
      if(!this.videoScreenDom){
        this.videoScreenDom = document.getElementById("video-screen");
      }
      this.screenRecorder = new MediaRecorder(stream,{
        mimeType : 'video/webm'
      });
      this.videoScreenDom.srcObject = stream;
      this.videoScreenDom.play();
      this.screenRecorder.start(this.recordTime);
    },
    
    onCameraSuccess(stream) {
      console.log("已开启摄像头");
      const track = stream.getVideoTracks()[0];
      const settings = track.getSettings();
      console.log("摄像流属性：", settings);
      let that = this
      this.deviceTestResult.camera = true
      this.deviceTestResult.microphone = true 
      if(!this.videoCameraDom){
        this.videoCameraDom = document.getElementById("video-camera");
      }
      this.mediaRecorder = new MediaRecorder(stream,{
        mimeType : 'video/webm'
      });
      this.videoCameraDom.srcObject = stream;
      this.videoCameraDom.play();
      this.mediaRecorder.start(this.recordTime);
    },
    //开启摄像头失败
    onCameraError(e) {
      this.deviceTestResult.camera = false
      this.deviceTestResult.microphone = false
      switch (e.name) {
        case 'NotAllowedError':
          this.deviceTestResult.failedReasonCamera ='您拒绝了访问摄像头/麦克风的请求，请开启相关权限';
          break;
        case 'NotFoundError':
          this.deviceTestResult.failedReasonCamera = '未检测到摄像头';
          this.nocamaraTipVisible = true
          break;
        case 'NotReadableError':
          this.deviceTestResult.failedReasonCamera ='摄像头无法读取，请检查摄像头是否被占用';
          break;
        case 'OverconstrainedError':
          this.deviceTestResult.failedReasonCamera ='摄像头被占用或不支持请求的媒体类型';
          break;
        case 'TypeError':
          this.deviceTestResult.failedReasonCamera = '返回的数据格式不支持';
          break;
        default:
          this.deviceTestResult.failedReasonCamera = '未知错误：' + e.name + ':' + e.message;
          this.nocamaraTipVisible = true
          break;
      }
    },
    //开启屏幕录像失败
    onScreenError(e){
      console.log(e);
      this.deviceTestResult.screenrecord = false
      let msg = e.message.toLowerCase()
      if(msg.includes('permission')){
        this.deviceTestResult.failedReasonScreen = '没有录制屏幕的权限，请允许录屏'
      }else{
        this.deviceTestResult.failedReasonScreen = msg
      }
    },
    //浏览器检测
    checkBroswer() {
      if(this.checkChromeVersion() >= 94){
        this.deviceTestResult.browser = true
      }else{
        this.deviceTestResult.browser = false
      }
      return this.deviceTestResult.browser
    },
    checkChromeVersion(){
      if(navigator.userAgent.indexOf('Wechat') > -1){
        alert("请不要在微信内打开本页面")
        return false;
      }
      var arr = navigator.userAgent.split(' '); 
      var chromeVersion = '';
      for(var i=0;i < arr.length;i++){if(/chrome/i.test(arr[i]))chromeVersion = arr[i]}
      if(chromeVersion){return Number(chromeVersion.split('/')[1].split('.')[0]);} 
      else {return false;}
    },
  },
};
</script>
<style scoped>
#video-camera {
  border: 1px solid #ff4810;
}
#video-screen{
  border: 1px solid #154fff;
}

.enable-check-btn{
  position: absolute;
  left: 55px;
  top: 55px;
}
</style>